import { render, staticRenderFns } from "./SubscriptionTermsV2.vue?vue&type=template&id=42e8e91c&scoped=true"
import script from "./SubscriptionTermsV2.vue?vue&type=script&lang=js"
export * from "./SubscriptionTermsV2.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTermsV2.vue?vue&type=style&index=0&id=42e8e91c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e8e91c",
  null
  
)

export default component.exports